import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-cme-nudge-modal',
  templateUrl: './cme-nudge-modal.component.html',
  styleUrls: ['./cme-nudge-modal.component.scss']
})
export class CmeNudgeModalComponent implements OnChanges {
  @Input() nudge_data;
  showModal = true;
  config;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  suggestionObj: any;
  constructor() {
    // No Code
  }

  ngOnChanges(): void {
    this.suggestionObj = { product_type_id: this.nudge_data.products[0].product_type_id, product_type: this.nudge_data.product_type, section: 'feed_detail', offset: 1 };

  }

  closeModal(): void {
    this.showModal = false;
  }

}
